import { FEEDBACK_EMAIL } from '../constants';

const createTicket = ({ subject, name, email, comment }) => {
  const mailtoLink = `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(
    `Name: ${name}\nEmail: ${email}\n${comment}\n`
  )}`;

  window.location.href = mailtoLink;
};

export const signUp = ({ name, email, phone, company, notes }) => {
  const subject = 'AdTools: New User Sign Up Request';
  const comment = `Phone: ${phone}\nCompany: ${company}\nNotes:\n${notes ?? ''}`;

  return createTicket({
    subject,
    name,
    email,
    comment,
  });
};

export const sendFeedback = ({ name, email, feedback }) => {
  const subject = 'AdTools: Feedback';
  const comment = `Feedback: ${feedback ?? ''}`;

  return createTicket({
    subject,
    name,
    email,
    comment,
  });
};
